export default "__VITE_ASSET__DdQupzeR__"